module.exports = __webpack_public_path__ + "img/phone_ico.d155ff12.png";